import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { User, SessionService } from '@edl-development/edl-common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StateService } from "@uirouter/angular";
import { error } from 'console';
import { multiFactor } from 'firebase/auth';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/modals/modal.service';
import { SchoolYearSchedule } from 'src/app/model/school-year-schedule';

@Component({
    selector: 'authenticated-header',
    templateUrl: './authenticated-header.component.html',
    styleUrls: ['./authenticated-header.component.scss']
})

export class AuthenticatedHeaderComponent implements OnInit, OnDestroy {
    user?: User;
    activeUserSub?: Subscription;

    messagesParams!: { page: number, start: string | null, end: string | null };
    datePipe = new DatePipe('en-US');


    constructor(
        private stateService: StateService,
        private sessionService: SessionService,
        private modalService: ModalService
    ) { }

    ngOnInit() {

        this.activeUserSub = this.sessionService.activeUser.subscribe((user: User) => {
            this.user = user;
            //flag for tracking if the message has been displayed to the user already
            let mfad = this.sessionService.GetSessionValue('000MFAD');
            var AuthUser = this.sessionService.GetAuthApp().currentUser!;
            if(AuthUser){
              const multiFactorUser = multiFactor(AuthUser);
              let mfaMissing = multiFactorUser.enrolledFactors.length === 0;
              let sqMissing = !this.user.SQPresent;
              var isUA = this.stateService.current.name === 'public.user-agreement';

              if(this.user.MFAEnforced && (mfad == null || mfad == false) && (mfaMissing || sqMissing) && !isUA) {

                  this.modalService.notifyOfMFAEnforcement(this.user, false)
                  .then((result) => {
                    if (result) {
                      this.stateService.go('authenticated.users.user.edit', {userId: user?.UserID});
                    }
                  }).catch(error => {});

                  this.sessionService.SetSessionValue('000MFAD', true);
              }
            }

        });
        this.messagesParams = this.generateMessagesParams();

    }

    ngOnDestroy(): void {
        this.activeUserSub?.unsubscribe();
    }

    private generateMessagesParams() {
        const schoolYear = new SchoolYearSchedule();

        return {
            page: 1,
            start: this.datePipe.transform(schoolYear.StartDate, 'MM/dd/yyyy'),
            end:this.datePipe.transform(schoolYear.EndDate,'MM/dd/yyyy'),
        }
    }

    public logout() {
        this.stateService.go('public.logout');
    }
}
